export default {"src":"/_next/static/media/bg_line_Urgent.c8887fbc.svg","height":305,"width":127,"blurWidth":0,"blurHeight":0};